import { Delete } from '@wix/wix-ui-icons-common';
import React from 'react';
import {
  CollectionOptimisticActions,
  DeleteManyParams,
  FiltersMap,
} from '@wix/bex-core';
import { ActionsCellAPI } from '../../state';

export interface DeleteSecondaryActionProps<T, F extends FiltersMap, R>
  extends DeleteManyParams<T, R> {
  optimisticActions: CollectionOptimisticActions<T, F>;
  actionsCellAPI: ActionsCellAPI<T, F>;
}

export function deleteSecondaryAction<T, F extends FiltersMap, R>(
  props: DeleteSecondaryActionProps<T, F, R>,
) {
  const {
    optimisticActions,
    actionsCellAPI: { openConfirmDeleteModal, collection, keyedItem },
    ...deleteManyParams
  } = props;
  const { translate: t } = collection;
  return {
    dataHook: 'collection-delete-action',
    text: t('cairo.delete.button'),
    icon: <Delete />,
    onClick: () => {
      openConfirmDeleteModal({
        primaryButtonOnClick: () => {
          optimisticActions.deleteOne(keyedItem.item, deleteManyParams);
        },
      });
    },
  };
}
